const trustPoints = [
  { icon: 'ri-verified-badge-line', label: 'Gerçek kampanyalar', color: '#22d3ee' },
  { icon: 'ri-notification-3-line', label: 'Anında bildirim', color: '#a855f7' },
  { icon: 'ri-price-tag-3-line', label: 'Ücretsiz kayıt', color: '#10b981' },
  { icon: 'ri-shield-check-line', label: 'KVKK uyumlu sistem', color: '#f59e0b' },
];

export default function TrustSection() {
  return (
    <section id="nasil-calisir" className="bg-[#0a0a0f] py-20 px-4 md:px-8">
      <div className="max-w-5xl mx-auto">
        {/* Glass card */}
        <div
          className="rounded-3xl p-8 md:p-12 text-center"
          style={{
            background: 'linear-gradient(135deg, rgba(168,85,247,0.08), rgba(6,182,212,0.06))',
            border: '1px solid rgba(168,85,247,0.2)',
            backdropFilter: 'blur(20px)',
          }}
        >
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-purple-500/10 border border-purple-500/20 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-map-pin-2-line text-purple-400 text-sm" />
            <span className="text-purple-300 text-xs font-medium tracking-wide uppercase">
              Türkiye Geneli Ağ
            </span>
          </div>

          <p
            className="text-white text-xl md:text-2xl font-semibold leading-relaxed max-w-3xl mx-auto mb-10"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Kampanya Kupon, Türkiye genelinde anlaşmalı firmalarla{' '}
            <span
              className="bg-clip-text text-transparent"
              style={{ backgroundImage: 'linear-gradient(135deg, #a855f7, #06b6d4)' }}
            >
              en avantajlı kampanyaları
            </span>{' '}
            doğrudan sana ulaştırır.
          </p>

          {/* Trust bullets */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {trustPoints.map((point) => (
              <div
                key={point.label}
                className="flex flex-col items-center gap-3 p-5 rounded-2xl transition-all duration-300 hover:scale-105 cursor-default"
                style={{
                  background: `${point.color}10`,
                  border: `1px solid ${point.color}25`,
                }}
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center"
                  style={{ background: `${point.color}20` }}
                >
                  <i className={`${point.icon} text-2xl`} style={{ color: point.color }} />
                </div>
                <span className="text-white text-sm font-medium text-center leading-tight">
                  {point.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* How it works */}
        <div id="hakkinda" className="mt-16 text-center">
          <h2
            className="text-2xl md:text-3xl font-bold text-white mb-10"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            3 Adımda{' '}
            <span
              className="bg-clip-text text-transparent"
              style={{ backgroundImage: 'linear-gradient(135deg, #a855f7, #ec4899)' }}
            >
              Kampanya Fırsatı
            </span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                step: '01',
                icon: 'ri-cursor-line',
                title: 'Alan Seç',
                desc: 'İlgilendiğin kategoriyi tek tıkla seç. Üye olmana gerek yok.',
                color: '#a855f7',
              },
              {
                step: '02',
                icon: 'ri-whatsapp-line',
                title: 'WhatsApp Açılır',
                desc: 'Otomatik olarak hazırlanan mesaj taslağı WhatsApp\'a iletilir.',
                color: '#22c55e',
              },
              {
                step: '03',
                icon: 'ri-gift-2-line',
                title: 'Fırsatları Al',
                desc: 'Seçtiğin alana özel kampanyalar doğrudan WhatsApp\'ına gelir.',
                color: '#f59e0b',
              },
            ].map((step) => (
              <div
                key={step.step}
                className="relative p-6 rounded-2xl text-left group hover:scale-105 transition-all duration-300"
                style={{
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(255,255,255,0.08)',
                }}
              >
                <span
                  className="text-5xl font-bold opacity-10 absolute top-4 right-5 select-none"
                  style={{ fontFamily: "'Space Grotesk', sans-serif", color: step.color }}
                >
                  {step.step}
                </span>
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center mb-4"
                  style={{ background: `${step.color}20` }}
                >
                  <i className={`${step.icon} text-xl`} style={{ color: step.color }} />
                </div>
                <h3
                  className="text-white font-semibold text-lg mb-2"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {step.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
